import { Link } from "react-router-dom";
import { Coins } from "lucide-react";
import { useSession } from "../_shims";
import { useCredits } from "../lib/hooks";
import { CREDITS_VISIBLE } from "../lib/credits";
import { creditBalanceLabel } from "@/features/home/focus";

/** Credit balance for the nav; links to the credits panel. Renders nothing when signed out or before the first load. */
export function CreditChip({ compact }: { compact?: boolean }) {
  const { isSignedIn } = useSession();
  const credits = useCredits();
  if (!CREDITS_VISIBLE || !isSignedIn || !credits.data) return null;
  const label = creditBalanceLabel(credits.data.status.creditsRemaining);
  return (
    <Link to="/network?tab=shares" title={`${label}. Open credits and shares.`} data-testid="credit-chip" style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "1px 7px", borderRadius: "var(--radius-full)", background: "var(--accent-soft)", color: "var(--accent)", fontSize: 11, fontWeight: 600, textDecoration: "none", lineHeight: 1.6, flex: "none" }}>
      <Coins size={11} />
      {compact ? (credits.data.status.creditsRemaining ?? "..") : label}
    </Link>
  );
}
